import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import "../style.css";

import { Link } from "react-router-dom";
import EnquiryModal from "../../../models/enquiries.modal"
import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
const PendingEnquiries = () => {
  const [modal1, setModal1] = useState(false);

  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };

  const [modal4, setModal4] = useState(false);

  const toggleModal4 = () => {
    setModal4(!modal4);
  };
  const[data, setData] =useState(); 
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }


 

 

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          contact_usModel.delete(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
           // getListData();
          });
        }
      });
  };
  const [selectedClassType, setSelectedClassType] = useState("");

  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };


  const [enquriId,setEnquriId] =  useState()
const [enquriStatus,setEnquriStatus] =  useState()
 

  const Pending = async()=>{
    setIsLoading(true);
    
    // Dummy data for pending enquiries
    const dummyPendingData = {
      data: [
        {
          _id: "1",
          id: "1",
          status: "pending_enq",
          Created_ON: "2024-01-15T10:30:00Z",
          followup_date: "2024-01-22T14:00:00Z",
          class_type: "Separate Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Rajesh",
              last_name: "Kumar",
              username: "9876543210"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "1", name: "Arjun Kumar", class: "10" },
            { id: "2", name: "Priya Kumar", class: "8" }
          ]
        },
        {
          _id: "2",
          id: "2",
          status: "pending_enq",
          Created_ON: "2024-01-16T14:20:00Z",
          followup_date: "2024-01-23T10:30:00Z",
          class_type: "Combined Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Sunita",
              last_name: "Sharma",
              username: "9876543211"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "3", name: "Vikash Sharma", class: "12" }
          ]
        },
        {
          _id: "3",
          id: "3",
          status: "pending_enq",
          Created_ON: "2024-01-17T09:15:00Z",
          followup_date: "2024-01-24T16:00:00Z",
          class_type: "SME",
          studentApi_parent: {
            auth_user: {
              first_name: "Amit",
              last_name: "Verma",
              username: "9876543212"
            },
            modeOfTution: "Hybrid"
          },
          students: [
            { id: "4", name: "Sneha Verma", class: "11" },
            { id: "5", name: "Rohit Verma", class: "9" },
            { id: "6", name: "Kavya Verma", class: "7" }
          ]
        },
        {
          _id: "4",
          id: "4",
          status: "pending_enq",
          Created_ON: "2024-01-18T16:45:00Z",
          followup_date: "2024-01-25T11:00:00Z",
          class_type: "Separate Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Meera",
              last_name: "Patel",
              username: "9876543213"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "7", name: "Karan Patel", class: "6" }
          ]
        },
        {
          _id: "5",
          id: "5",
          status: "pending_enq",
          Created_ON: "2024-01-19T11:30:00Z",
          followup_date: "2024-01-26T15:30:00Z",
          class_type: "Combined Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Deepak",
              last_name: "Singh",
              username: "9876543214"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "8", name: "Anita Singh", class: "10" },
            { id: "9", name: "Ravi Singh", class: "12" }
          ]
        }
      ],
      meta: {
        current_page: 1,
        per_page: 10,
        total_page: 1,
        total: 5
      }
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setData(dummyPendingData);
      setCurrentPage(dummyPendingData.meta.current_page);
      setPerPage(dummyPendingData.meta.per_page);
    }, 1000);
  }
    useEffect(()=>{
      Pending();
    },[])
    useEffect(()=>{
      Pending();
    },[currentPage])
     //for Disqualify pending enqury(firdosh)
     const Disqualify= (event) => {
      event.preventDefault();
      
      // Simulate disqualifying enquiry
      setTimeout(() => {
        setData(prevData => ({
          ...prevData,
          data: prevData.data.filter(item => item.id !== enquriId)
        }));
        helper.sweetalert.toast("Enquiry disqualified successfully", "success");
        toggleModal2();
      }, 500);
  };
  return (
    <>
      <div>
      <Container className="pt-7">
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Pending Enquiry</h3>
                  <div className="d-flex flex-row">
                    <Input
                      className="mr-4"
                      type="text"
                      placeholder="Search"
                      size="sm"
                    />
                  </div>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Guardian Name (Mobile No)</th>
                      <th scope="col">Mode of Tuition</th>
                      <th scope="col">Status</th>
                      <th scope="col">No of Students</th>
                      <th scope="col"> Date & Time of Enquiry</th>
                      <th scope="col"> Follow up Date</th>

                      <th>Action</th>
                      <th scope="col" />
                    </tr>
                  </thead>
              
                  {!isLoading && (
                    <tbody>
                      {data?.data.length > 0 ? (
                        data?.data.map((item, index) => {
                          const date = new Date(item?.Created_ON);
                        
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                        const year = date.getFullYear();
                        let hours = date.getHours();
                        const minutes = String(date.getMinutes()).padStart(2, '0');
                        const ampm = hours >= 12 ? 'pm' : 'am';
                       hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight (0 hours)
                       const formattedTime = `${hours}:${minutes}${ampm}`;
                       const formatteddate = `${day}/${month}/${year}`
                       const finaldate = `${formatteddate} ${formattedTime}`
                       
                       const datee = new Date(item?. followup_date);
                        
                        const dayy = String(datee.getDate()).padStart(2, '0');
                        const monthh = String(datee.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                        const yearr = datee.getFullYear();
                        let hourss = datee.getHours();
                        const minutess = String(datee.getMinutes()).padStart(2, '0');
                        const ampmm = hourss >= 12 ? 'pm' : 'am';
                       hourss = hourss % 12 || 12; // Convert to 12-hour format and handle midnight (0 hours)
                       const formattedTimee = `${hourss}:${minutess}${ampmm}`;
                       const formatteddatee = `${dayy}/${monthh}/${yearr}`
                       const folowup = `${formatteddatee} ${formattedTimee}`
                      

                            console.log("pending data",item)
                          return (
                            <tr key={item._id} style={{ cursor: "pointer" }} >
                            <td  id="tabledata">
                                  {/*{(currentPage - 1) * perPage + index + 1}
                                  */}{index + 1}
                                </td>
                              {/* <td>{item?.parent_name || "-"}</td> */}
                              <td className="p-0 pl-3" id="tabledata">
                                {" "}
                                <Link to={`/admin/viewenquiry/${item.id}`}>
                                  {item?.studentApi_parent?.auth_user?.first_name}{" "}
                                  {item?.studentApi_parent?.auth_user?.last_name}
                                </Link>
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {" "}
                                  {item?.studentApi_parent?.auth_user?.username}
                                  <span style={{ marginLeft: "3px" }}>
                                    <i class="fa-solid fa-phone"></i>
                                  </span>
                                </span>
                                {/* <br />
                                <p
                                  style={{
                                    backgroundColor: "orange",
                                    color: "white",
                                    padding: "5px",
                                    borderRadius: "5px",
                                    fontSize: "12px",
                                    marginTop: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer ",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Requested Call Back
                                </p> */}
                              </td>
                              <td>{item?.class_type || "-"}</td>
                              <td className="p-0" id="tabledata">
                                {" "}
                                <span
                                  style={{
                                    backgroundColor: "orange",
                                    color: "white",
                                    padding: "5px",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item?.status}
                                </span>
                              </td>
                              <td id="tabledata">
                                {" "}
                                <span
                                  style={{
                                    backgroundColor: "orange",
                                    color: "white",
                                    padding: "7px",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item?.students?.length}
                                </span>
                              </td>
                              <td>{finaldate || "-"}</td>

                              <td>{folowup || "-"}</td>
                              <td
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                                className="p-0"
                              >
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target="eyeTooltip"
                                >
                                  View
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    borderRadius: "30%",
                                  }}
                                  id="eyeTooltip"
                                  to={`/admin/viewenquiry/${item?.studentApi_parent?.auth_user?.username}/${item?.id}`}
                                >
                                  <i class="fa-solid fa-eye" ></i>
                                </Link>

                                <UncontrolledTooltip
                                  placement="bottom"
                                  target="checkTooltip"
                                >
                                  Qualified
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "green",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="checkTooltip"
                                  to={`/admin/qualifiedenquiriesviewpage/${item.id}`}
                                >
                                  <i class="fa-solid fa-check"></i>
                                </Link>

                                {/* <UncontrolledTooltip
                        placement="top"
                        target="clockTooltip"
                      >
                        Pending
                      </UncontrolledTooltip>
                      <p style={{ margin: "0 5px",color:"orange" }} id="clockTooltip"    onClick={toggleModal1}>
                        <i class="fa-solid fa-clock-rotate-left"></i>
                      </p> */}

                                <UncontrolledTooltip
                                  placement="bottom"
                                  target="userTooltip"
                                >
                                  Disqualified
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "red",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="userTooltip"
                              
                                  onClick={() => {
                                    toggleModal2();
                                    
                                    setEnquriId(item.id);
                                   
                                  }}
                                  
                                >
                                  <i class="fa-solid fa-user-xmark"></i>
                                </p>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="10" style={{ verticalAlign: "middle" }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                  {/* code*/}
                </Table>
                <CardFooter className="py-4">
                  <TablePagination
                    totalPages={parseInt(data?.meta?.total_page)}
                    currentPage={parseInt(data?.meta?.current_page)}
                    pageUrl="/admin/pendingenquiries?"
                  />
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}
        <Modal isOpen={modal1} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <h4> Assign Tutors</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Select Tutors</Label>
                  <Input
                    id="forType"
                    type="select"
                    // onChange={(e) => {
                    //   interViewUser(e.target.value, "board");
                    // }}
                  >
                    <option value="">select Option</option>
                    {/* {dataList &&
                      dataList?.map((item, index) => {
                        return (
                          <option value={item.mobile}>
                            {item.user?.first_name} ({item?.mobile})
                          </option>
                        );
                      })} */}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>
            <h4>Enquiry Pending </h4>
          </ModalHeader>
          <ModalBody>
            <Input type="textarea" placeholder="Enter Reason" />
            <Input type="date" className="mt-3" />
            <Input type="time" className="mt-3" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal3} toggle={toggleModal2}>
          <ModalHeader toggle={toggleModal2}>
            <h4> Enquiry Disqualify</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={Disqualify}>

            <Input type="textarea" placeholder="Enter Reason" name="remark" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal2}>
                Cancel
              </Button>

              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                // onClick={}
              >
                Save
              </Button>
            </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal4} toggle={toggleModal4}>
          <ModalHeader toggle={toggleModal4}>
            <h4> Enquiry Disqualify</h4>
          </ModalHeader>
          <ModalBody>
          <Form >

              
                <Row>
                  <Col md={6}>
                    <Label>Type of Class</Label>
                    <Input
                      id="forType"
                      type="select"
                     name="class_type"
                    >
                      <option value="">Select Class Type</option>
                      <option value="Separate Class">Separate Class</option>
                      <option value="Combined Class">Combined Class</option>
                      <option value=" SME"> SME</option>
                    </Input>
                  </Col>
                  <Col md={6}>
                    <Label >Assign to</Label>
                    <Input
                      id="forType"
                      type="select"
                      name="assigned_to"
                      
                    >
                      <option value="">Select Assign to</option>
                      <option value="Pawan">Pawan</option>
                      <option value="Amit">Amit</option>
              
                    </Input>
                  </Col>
                </Row>
                <Row>
                <Col md={6} className="mt-3">
                    <Label >Remark/Feedback (Internal)</Label>
                    <Input
                      type="textarea"
                      placeholder="Enter Remark/Feedback"
                      name="remark"
                    />
                  </Col>{" "}
                  <Col md={6} className="mt-3">
                    <Label >Remark/Feedback (For tutor)</Label>
                    <Input
                      type="textarea"
                      placeholder="Enter Remark/Feedback"
                      name="tutor_remark"
                    />
                  </Col>
                </Row>
               
                <div style={{ marginTop: "10px" }}>
                <Row>
                    <Col md={12} style={{ float: "right" }}>
                    <Button
                        type="submit"
                        style={{
                          backgroundColor: "green",
                          color: "white",
                          float: "right",
                      
                        }}
                        // tag={Link}
                        // to={`/admin/qualifiedenquiriesviewpage`}
                        // onClick={toggleModal1}
                      >
                        Qualified
                      </Button>
                      {/* <Button
                        type="submit"
                        style={{
                          backgroundColor: "#fcb603",
                          color: "white",
                          float: "right",
                        }}
                        onClick={toggleModal1}
                      >
                        Pending
                      </Button>
                      <Button
                        type="submit"
                        // style={{ float: "right", marginTop: "20px" }}
                        onClick={toggleModal2}
                        style={{
                          backgroundColor: "#fc0f03",
                          color: "white",
                          float: "right",
                        }}
                      >
                        Disqualified
                      </Button> */}
                    </Col>
                  </Row>
                </div>

                </Form>
          </ModalBody>
        </Modal>
      </Container>
      </div>
    </>
  );
};

export default PendingEnquiries;
